import { render, staticRenderFns } from "./adsorption-methods-detail.vue?vue&type=template&id=2776a646&"
import script from "./adsorption-methods-detail.vue?vue&type=script&lang=js&"
export * from "./adsorption-methods-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports